import { FC } from 'react';

import { InputWithSearchIcon } from 'common/components';
import { ACTION_ITEMS } from 'common/config/action.config';

import './Header.scss';

type HeaderProps = {
    searchVal: string;
    onSearchChangeHandler: (e: any) => void;
};

const Header: FC<HeaderProps> = ({ searchVal, onSearchChangeHandler }: HeaderProps) => {
    return (
        <div className="archive-list-header-container">
            <div className="archive-list-header header-default">Archived Items</div>
            <div className="archive-list-header-right">
                <InputWithSearchIcon
                    placeholder={ACTION_ITEMS.SEARCH_BUTTON}
                    value={searchVal}
                    className="search-input"
                    onChange={onSearchChangeHandler}
                    hideClearButton={false}
                />
            </div>
        </div>
    );
};

export default Header;
